import { useState, useEffect } from "react";
import {ApiUrl} from "../../ApiUrl"
const useFetchCities = () => {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchCities = async () => {
      const apiURL = `${ApiUrl.apiurl}CITY/GetAllCity/`;
      try {
        const response = await fetch(apiURL);
        const result = await response.json();
        if (response.ok) {
          setCities(Array.isArray(result?.data) ? result.data : []);
        } else {
          setError(result.message);
        }
      } catch (err) {
        setError("Failed to fetch countries");
        setCities([]);
      } finally {
        setLoading(false);
      }
    };
    fetchCities();
  }, []);
  return { cities, loading, error };
};
export default useFetchCities;